module.exports = __webpack_public_path__ + "static/img/star.2ba8ed4.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/news2/star.png
// module id = hVU0
// module chunks = 7